
var TECL_TenderBasicInfoFileManager = {

  // Initialise basic info control
  Initialise: function() {
    TECL_DateTime.InitialiseDateTimePickers("#tenderBasicInformation");
  },

  // Save basic changes
  SaveChanges: function() {
    var saveData = TECL_TenderBasicInfoFileManager.GetSaveData();

    if (saveData) {
      TECL_Master.AddLock("TECL_TenderBasicInfoFileManager_SaveChanges");

      $.ajax({
        url: baseSiteUrl + "TenderUserSurface/UpdateBasicTenderDetails",
        type: "POST",
        data: {
          saveData: saveData
        },
        error: function() {
          TECL_Master.ClearLock("TECL_TenderBasicInfoFileManager_SaveChanges");
          TECL_Master.ShowErrorDialog("Unknown error");
        },
        success: function(result) {
          TECL_Master.ClearLock("TECL_TenderBasicInfoFileManager_SaveChanges");

          if (result) {
            TECL_Master.DisplayNoticeDlg("Project details updated.");
          } else {
            TECL_Master.ShowErrorDialog("Unknown error");
          }
        }
      });
    }
  },

  // Get the tender details
  GetSaveData: function() {
    var saveData = null;
    var $mainDiv = $("#tenderBasicInformation");

    if ($mainDiv && $mainDiv.length > 0) {
      var tenderId = $("#TenderId").val();
      var quoteClosingDate = TECL_DateTime.GetDateTimePickerStringValue($mainDiv.find("#QuoteClosingDateCntrl"));
      var productDeliveryDate = TECL_DateTime.GetDateTimePickerStringValue($mainDiv.find("#ProductDeliveryDateCntrl"));
      var description = $mainDiv.find("textarea#tenderDescription").val();
      var budget = $mainDiv.find("#tenderBudgetValue").val();
      var saveFileDatas = TECL_TenderBasicInfoFileManager.GetFileDatas();

      saveData = {
        TenderId: tenderId,
        QuoteClosingDate: quoteClosingDate,
        ProductDeliveryDate: productDeliveryDate,
        Description: description,
        Budget: budget,
        FilesDatas: saveFileDatas
      };
    }
    return saveData;
  },

  // Get uploaded proposal files for a document type
  GetFileDatas: function() {
    var saveFileDatas = [];
    var $mainDiv = $("#tenderBasicInformation");

    if ($mainDiv && $mainDiv.length > 0) {
      var $listContainer = $mainDiv.find("[name=tenderBasicInfoFileList]");

      if ($listContainer && $listContainer.length > 0) {

        $listContainer.find("[name=filesListItem]").each(function() {
          // Add file data to the array
          var id = $(this).attr("data-documentId");
          var fieldName = $(this).attr("data-fileName");
          var deleted = $(this).hasClass("hidden");

          fileData = {
            Id: id,
            Filename: fieldName,
            DocumentType: 4,
            Deleted: deleted
          }

          saveFileDatas.push(fileData);
        });
      }
    }
    return saveFileDatas;
  },

  // Called on file upload success
  onSuccess_tenderBasicInfoFileManager: function(e) {
    if (TECL_Master.AddLock("onSuccess_tenderBasicInfoFileManager")) {
      if (e.operation === "upload" && e.files != null && e.files.length > 0) {
        var file = e.files[0].rawFile;
        var fileName = file.name;
        if (file) {
          $.ajax({
            url: baseSiteUrl + "TenderUserSurface/SaveDownloadedFile",
            type: "POST",
            data: {
              fileName: fileName,
              tenderId: $("#TenderId").val()
            },
            error: function() {
              TECL_Master.ClearLock("onSuccess_tenderBasicInfoFileManager");
            },
            success: function(html) {
              TECL_Master.ClearLock("onSuccess_tenderBasicInfoFileManager");
              if (html && html.length > 0) {
                var $listContainer = $("#FileUploader_FileManagerId").find("[name=tenderBasicInfoFileList]");

                if ($listContainer && $listContainer.length > 0) {
                  $(html).appendTo($listContainer);
                }
              }
            }
          });
        }
      }
    }
  }

};